import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';
import { AppState } from '../../config/state';
import { DatabaseProvider } from '../database/database';

/*
  Generated class for the StaffAuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class StaffAuthProvider {

  constructor(public http: HttpClient, private api: ApiProvider, private state: AppState, private _db: DatabaseProvider, private _apiService: ApiProvider) {
  }

  public load(): Promise<any> {
    return this._db.get("staffCredentials").then((staffDetails) => {
      if (!staffDetails) {
        return undefined;
      }
      this.state.staffCredentials = {
        username: staffDetails.username,
        password: staffDetails.password,
        details: staffDetails.details,
      }
      this.state.staffAuthorized = true;
      this.state.authentication = {
        key: staffDetails.details.keys.key,
        secret: staffDetails.details.keys.secret,
      };
      return staffDetails;
    });
  }

  public clear() {
    this.state.staffCredentials = {
      username: undefined,
      password: undefined,
      details: undefined,
    }
    this.state.staffAuthorized = false;
    this.state.authentication = {
      key: undefined,
      secret: undefined,
    };
    this._db.remove("staffCredentials");
  }

  public async authUser(username: string, password: string, cfg: any, appId?: number) {
    console.log("appid", appId);
    const query = `{
      authenticateUser(username: "${username}" password:"${password}" ${appId ? 'forClientId:' + appId : ''}) {
        id username firstName lastName clientId access keys
      }
    }`
    // console.log(cfg);
    let details = await this.api.query(query);

    if (details.authenticateUser && details.authenticateUser.id) {
      const user = details.authenticateUser;
      this.state.staffAuthorized = true;
      this.state.authentication = {
        key: user.keys.key,
        secret: user.keys.secret
      }
      this.state.staffCredentials = {
        username: username,
        password: password,
        details: user
      }
      if ((this.state.staffCredentials.details.clientId == -1 && this.state.staffCredentials.details.access.level == 1) || this.state.staffCredentials.details.access.level != 1) {
        this._db.set("staffCredentials", {
          username: username,
          password: password,
          details: user
        });
      }

    }

    await this._apiService.resetToken();

    if (details.authenticateUser && details.authenticateUser.id && (details.authenticateUser.clientId === -1 || details.authenticateUser.clientId === cfg.clientId || cfg.clientId === 0)) {
      if (details.authenticateUser.access.level < 4) {
        return details.authenticateUser;
      } else if (details.authenticateUser.access.level === 4 && details.authenticateUser.access.roam) {
        return details.authenticateUser;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  public async setAuthentication(username: string, level: number, key: string, secret: string, firstName: string, lastName: string) {
    return new Promise(async (resolve) => {
      this.state.staffAuthorized = true;
      const details = {
        username,
        firstName,
        lastName,
        access: {
          level
        },
        keys: {
          key,
          secret
        }
      };
      this.state.authentication = {
        key: key,
        secret: secret
      }
      this.state.staffCredentials = {
        username,
        password: null,
        details
      }
      this._db.set("staffCredentials", {
        username,
        password: null,
        details
      });
      await this._apiService.resetToken();
      resolve(true);
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/staff-auth/staff-auth.ts